<template lang="pug">
//iframe#container(style="width:100%;height:800px;")
.wrapper(class="slideWrapper")
  .page-header
    .content-center
      #divider.row
        //iframe#container(style="width:100%;height:800px;")
        //iframe(width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=1dcbf3ae-44ea-4ce0-acb4-f1707a8b0db2&autoAuth=true&ctid=36fc765b-b21f-4473-a2b1-c5d0e49baaba&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLWVhc3QtYS1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9" frameborder="0" allowFullScreen="true")
        //iframe(width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=d1f0262c-b058-4abd-b156-34c596fd5bf1&autoAuth=true&ctid=36fc765b-b21f-4473-a2b1-c5d0e49baaba&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLWVhc3QtYS1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9" frameborder="0" allowFullScreen="true")
        iframe(width="800" height="600" src="https://app.powerbi.com/rdlEmbed?reportId=e4eed20d-0ac7-4940-aef3-aefad8f53f08&autoAuth=true&ctid=36fc765b-b21f-4473-a2b1-c5d0e49baaba" frameborder="0" allowFullScreen="true")
</template>
<script>
import { mapState } from 'vuex';
import * as pbi from 'powerbi-client';
  export default {
    name: 'home',
    bodyClass: 'presentation-page',
    computed: {
        ...mapState({
            username: 'user'
            })
            },
  data() {
    return {
      }
      },

      beforeMount () {
      console.log('id',this.$route.params.id);
      },
      mounted () {
    var permissions = pbi.models.Permissions.All
var config = {
    "authenticationMode": "MasterUser",
    "authorityUri": "https://login.microsoftonline.com/common/v2.0",
    "scope": "https://analysis.windows.net/powerbi/api",
    "apiUrl": "https://api.powerbi.com/",
    "clientId": "c5751cca-cc1d-444f-80d5-70df438a80ff",
    "workspaceId": "a4c8fa69-f2fb-4be8-be93-8c782ba23027",
    "reportId": "eeeeab21-9fb2-4505-b787-02353789e0f9",
    "pbiUsername": "yousef.lasi@gmail.com",
    "embedUrl": "https://app.powerbi.com/reportEmbed?reportId=1dcbf3ae-44ea-4ce0-acb4-f1707a8b0db2&autoAuth=true&ctid=36fc765b-b21f-4473-a2b1-c5d0e49baaba&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLWVhc3QtYS1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9",
    "type": "report",
    "pbiPassword": "aBaloch!294",
}


    let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    var reportContainer = document.getElementById('container');
    var report = powerbi.embed(reportContainer, config);

    report.off("loaded");


    report.off("rendered");



    report.on("error", function () {
        this.report.off("error");
    });
      },
      methods: {
      showSignUp: function() {
      console.log('Request Access Modal')
      }
  }
  }
</script>
<style>
body.presentation-page  {
}

.presentation-page #app .page-header-city, .index-page .page-header-city {
top: 15.5%;
}

body.presentation-page .h3-description.rellax-text {
font-size: 2.5em;
}

body.presentation-page #app .rellax-text-container, .index-page .rellax-text-container {
    top: 150px;
    }
.presentation-page #app .rellax-text-container .h1-seo, #app .index-page .rellax-text-container .h1-seo {
    text-transform: lowercase;
    background: #19405c;
    -webkit-text-stroke: 1px #d6cfcf
}

.presentation-page #app .subtext .h3-description, .index-page .h3-description {
    display: inline-block;
    position: relative;
    margin-top: 100px;
    /*background-color: rgba(50,0,0,0.2);*/
    padding: 10px 12px;
    border-radius: 50px;
    opacity: 1;
    -webkit-transition: opacity 0.5s;
    transition: opacity 0.5s;
    width: auto;
    text-align: center;
    /*box-shadow: 0 5px 35px 0 rgba(0,0,0,.3);
    text-shadow: -5px 0px 20px rgba(50, 0, 0, 0.5), 5px 0px 20px rgba(50, 0, 0, 0.5), 0 -5px 20px rgba(50, 0, 0, 0.5), 0 5px 20px rgba(50, 0, 0, 0.5);*/
}
.presentation-page #app.scrolled .h3-description {
opacity: 0;
}

#app .subtext {
width: 100%;
text-align: center;
}
#app .rellax-text-container {
opacity: 1;
transition: opacity 0.75s;
}
#app.scrolled .rellax-text-container {
opacity: 0;
}

.signUp {
position: relative;
    z-index: 10;
        text-align: center;
            width: 100%;
                margin-top: -20px;
transition: opacity 0.75s;
                }

.presentation-page #app.scrolled .signUp {
opacity: 0;
}
.presentation-page #app .signUp a.btn.btn-primary {
    width: 100px;
    display: inline-block;
    height: 46px;
    color: white;
    border: 2px solid rgba(255,255,255,1);
    padding: 9px 0px;
    top: 50%;
    border-radius: 50px;
}
.presentation-page #app .signUp a:active, .presentation-page #app .signUp a:hover {
    border: 2px solid rgb(255,255,255);
    }
    .index-page .page-header, .presentation-page .page-header {
        height: 100vh;
        }
</style>
